// extracted by mini-css-extract-plugin
module.exports = {"Image":"Image_Image__19vht","Filesize":"Image_Filesize__20R1i","CompressionInfo":"Image_CompressionInfo__17u4_"};